<template>
  <section class="page-container">
    <header v-if="index" class="mb-12">
      <h2 class="section-title text-brand text-center">
        {{ index.title }}
      </h2>
    </header>
    <div class="flex flex-col gap-4 tablet:grid tablet:grid-cols-2">
      <ArticleCard
              v-for="item in items"
              :key="item.id"
              :class="{
                  'order-1': item?.meta?.weight === 1,
                  'order-2': item?.meta?.weight === 2,
                  'order-3': item?.meta?.weight === 3,
                  'order-4': item?.meta?.weight === 4,
                  'order-5': item?.meta?.weight === 5,
                  'order-6': item?.meta?.weight === 6,
                  'order-7': item?.meta?.weight === 7,
                  'order-8': item?.meta?.weight === 8,
              }"
              :image-dimensions="[]"
              :image-sizes="''"
              :odd="false"
              :page="item"
              theme="blank"
      />
      <picture
              v-if="indexImgUri"
              class="order-5 mb-8 tablet:py-0 tablet:px-12 laptop:px-14 desktop:px-16"
      >
        <media-source
                :dimensions="indexImgDimensions"
                :sizes="indexImgSizes"
                :uri="indexImgUri"
                as="source"
                format="webp"
        />
        <media-source
                :alt="index?.title || ''"
                :dimensions="indexImgDimensions"
                :sizes="indexImgSizes"
                :uri="indexImgUri"
                as="img"
                class-name="w-full h-full object-cover rounded-img aspect-3/2"
                format="jpg"
        />
      </picture>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";

const {pages} = defineProps<{
    pages: Array<PageCollectionItemBase>;
}>();
const {getIndex, getAllButIndex} = usePage();
const index = computed<PageCollectionItemBase | undefined>(() => getIndex(pages));
const items = computed<Array<PageCollectionItemBase>>(() => getAllButIndex(pages));
const indexImgUri = computed<string>(() => (index.value?.meta?.imageRef as string || '').replace('/assets', '') || '');
const indexImgDimensions = [
    {width: 800},
    {width: 1200},
    {width: 1600},
];
const indexImgSizes = '100vw, (min-width: 768) 50vw';
</script>